import { editorComponentSwitch } from '../editorComponentSwitch';

import { createGroup } from './Group';
import { GroupTools } from './GroupTools';

export const BlockGroup = editorComponentSwitch({
  editorComponent: createGroup(GroupTools),
  standardComponent: createGroup(),
});
